import React, { useState, useEffect } from 'react';
import { TextField, Button, Container, Typography, Box, InputAdornment, IconButton, useTheme } from '@mui/material';
import { Email as EmailIcon, Lock as LockIcon } from '@mui/icons-material';
import axiosInstance from './axiosConfig';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Register = () => {
  const { translate } = useLanguage();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [projectId, setProjectId] = useState(null); // Almacenar el projectId de la invitación
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const theme = useTheme();

  useEffect(() => {
    const projectIdFromUrl = searchParams.get('projectId');
    if (projectIdFromUrl) {
      setProjectId(projectIdFromUrl);
    }
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.post('/api/register', { email, password, projectId }); // Enviar projectId si está presente
      navigate('/'); // Redirige al login después de registrar
    } catch (err) {
      setError(translate('register.registrationError'));
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.mode === 'dark' ? '#121212' : '#333',
        color: theme.palette.text.primary,
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          backgroundColor: theme.palette.background.default,
          padding: theme.spacing(4),
          borderRadius: '12px',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.5)',
          textAlign: 'center',
        }}
      >
        <Typography variant="h4" gutterBottom>
          {translate('register.createAccount')}
        </Typography>
        <Typography variant="subtitle1" color="textSecondary" gutterBottom>
          {translate('register.registerToAccess')}
        </Typography>
        {error && <Typography color="error" align="center">{error}</Typography>}
        
        <form onSubmit={handleSubmit}>
          <TextField
            label={translate('register.email')}
            variant="outlined"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon color="action" />
                </InputAdornment>
              ),
            }}
            sx={{ backgroundColor: theme.palette.background.paper, borderRadius: 1 }}
          />
          <TextField
            label={translate('register.password')}
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon color="action" />
                </InputAdornment>
              ),
            }}
            sx={{ backgroundColor: theme.palette.background.paper, borderRadius: 1 }}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{
              mt: 3,
              py: 1.5,
              fontSize: '1rem',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.3)',
            }}
          >
            {translate('register.register')}
          </Button>
        </form>

        <Button
          onClick={() => navigate('/')}
          color="secondary"
          fullWidth
          sx={{
            mt: 3,
            py: 1.5,
            fontSize: '1rem',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.3)',
          }}
        >
          {translate('register.alreadyHaveAccount')}
        </Button>
      </Container>
    </Box>
  );
};

export default Register;
